import type { Entity } from "../index"
import type { HasEntityElevation } from "./HasEntityElevation.type"

export default function isEntityHasElevation(
  entity: Entity
): entity is Entity & HasEntityElevation {
  return 'elevation' in entity
}
